import filter from 'lodash/filter';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Events from '../components/events';

import eventPredicateFactories from '../filters/event-predicates';

const mapStateToProps = (state, ownProps) => ({
	eventPredicates: filter(
		eventPredicateFactories.map((factory) => factory(state.app))
	),
});

export default connect(mapStateToProps)(Events);
